import React from "react";
import AdminTW from "./AdminTW";
import EtegrisDashBoard from "./etegris/EtegrisDashboard";

const PageDashboard = () => {
	return (
		<AdminTW>
			<EtegrisDashBoard />
		</AdminTW>
	);
};

export default PageDashboard;
